import { useCallback } from 'react';

import { AgGridTable } from 'core/components';

import { RemoveExtractorVendorMappingsButton } from './RemoveExtractorVendorMappingsButton';
import { UpsertExtractorVendorMappingButton } from './UpsertExtractorVendorMapping';

interface IProps {
  canAdd?: boolean;
  canRemove?: boolean;
}

// Split from the provider so the Remove button can reach `selectedRows` / `deselectAllRows` from
// the table context — the toolbar callback itself is only handed `gridApi`.
export const ExtractorVendorMappingTable = ({ canAdd = false, canRemove = false }: IProps) => {
  const actionButtons = useCallback(
    () =>
      canAdd ? [<UpsertExtractorVendorMappingButton key="addExtractorVendorMappingButton" />] : [],
    [canAdd]
  );

  const selectionActionButtons = useCallback(
    () =>
      canRemove
        ? [<RemoveExtractorVendorMappingsButton key="removeExtractorVendorMappingsButton" />]
        : [],
    [canRemove]
  );

  return (
    <AgGridTable actionButtons={actionButtons} selectionActionButtons={selectionActionButtons} />
  );
};
